import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartStore } from '../../store';
import { EmptyState } from '../../components/common';
import QtyStepper from '../../components/common/QtyStepper';

const CartPage = () => {
  const { items, updateQty, removeItem, clearCart, getTotal } = useCartStore();
  const navigate = useNavigate();

  const subtotal = getTotal();
  const hasFullKit = items.some(i => i.kit_bundle);
  const tax = 0; // shown as estimate — calculated at checkout
  const total = subtotal;

  if (items.length === 0) return (
    <div className="container">
      <EmptyState icon="🛒" title="Your cart is empty" message="Add some products or a school kit to get started!" />
      <div className="text-center" style={{ marginTop: '1rem' }}>
        <button className="btn btn-primary" onClick={() => navigate('/')}>Start Shopping</button>
      </div>
    </div>
  );

  return (
    <div className="container" style={{ padding: '1.5rem 1rem' }}>
      <div className="page-header">
        <h1>Your Cart</h1>
        <p>{items.length} item types</p>
      </div>

      <div className="page-two-col">
        {/* Items */}
        <div className="page-col-main">
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <h2 style={{ fontWeight: 700 }}>Cart Items</h2>
              <button className="btn btn-sm" style={{ color: '#ef4444' }} onClick={clearCart}>Clear All</button>
            </div>
            {items.map(item => (
              <div key={item._key} style={styles.cartItem}>
                {(item.image_data || item.image_url) ? (
                  <img
                    src={item.image_data || item.image_url}
                    alt={item.name}
                    style={{ width: 52, height: 52, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', flexShrink: 0 }}
                  />
                ) : (
                  <div style={{ width: 52, height: 52, borderRadius: 8, background: '#f3f4f6', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', flexShrink: 0 }}>📦</div>
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>{item.name}{item.colors?.length > 0 && item.colors.map(c => <span key={c} style={{ marginLeft: '0.35rem', background: '#dbeafe', color: '#1e40af', borderRadius: 999, padding: '0.1rem 0.5rem', fontSize: '0.7rem', fontWeight: 600 }}>{c}</span>)}{!item.colors && item.color && <span style={{ marginLeft: '0.45rem', background: '#dbeafe', color: '#1e40af', borderRadius: 999, padding: '0.1rem 0.5rem', fontSize: '0.7rem', fontWeight: 600 }}>{item.color}</span>}</div>
                  <div style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                    {item.kit_id && <span style={{ background: '#dbeafe', color: '#1d4ed8', borderRadius: 4, padding: '0.1rem 0.35rem', fontSize: '0.68rem' }}>Kit Item</span>}
                  </div>
                  {!item.kit_id && (
                    <div style={{ fontSize: '0.88rem', color: '#2563eb', fontWeight: 600, marginTop: '0.2rem' }}>${parseFloat(item.price).toFixed(2)}</div>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                  <QtyStepper value={item.qty} onChange={qty => updateQty(item._key, qty)} min={0} />
                  <div style={{ fontWeight: 700, minWidth: 70, textAlign: 'right' }}>
                    {!item.kit_id ? `$${(item.price * item.qty).toFixed(2)}` : ''}
                  </div>
                  <button
                    style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem' }}
                    onClick={() => removeItem(item._key)}
                    title="Remove"
                  >🗑</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary */}
        <div className="page-col-side">
          <div className="card">
            <h2 style={{ fontWeight: 700, marginBottom: '1rem' }}>Order Summary</h2>
            <div style={styles.summaryRow}><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
            <div style={styles.summaryRow}>
              <span>Shipping</span>
              <span style={{ color: hasFullKit ? '#10b981' : '#6b7280', fontSize: hasFullKit ? undefined : '0.82rem' }}>
                {hasFullKit ? 'FREE 🎒' : 'Calculated at checkout'}
              </span>
            </div>
            <div style={styles.summaryRow}><span>Tax</span><span style={{ color: '#6b7280', fontSize: '0.82rem' }}>Calculated at checkout</span></div>
              {hasFullKit && (
                <div style={{ fontSize: '0.78rem', color: '#10b981', marginBottom: '0.75rem' }}>🎒 Free shipping on your full kit!</div>
              )}
            <div style={{ ...styles.summaryRow, borderTop: '2px solid #e5e7eb', paddingTop: '0.75rem', marginTop: '0.5rem', fontWeight: 800, fontSize: '1.1rem' }}>
              <span>Subtotal</span><span>${total.toFixed(2)}</span>
            </div>
            <button className="btn btn-primary btn-full btn-lg" style={{ marginTop: '1rem' }} onClick={() => navigate('/checkout')}>
              Proceed to Checkout →
            </button>
            <button className="btn btn-outline btn-full btn-sm" style={{ marginTop: '0.5rem' }} onClick={() => navigate('/products')}>
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  cartItem: {
    display: 'flex', alignItems: 'center', gap: '1rem',
    padding: '1rem 0', borderBottom: '1px solid #f3f4f6', flexWrap: 'wrap',
  },
  summaryRow: {
    display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem',
    padding: '0.3rem 0', color: '#374151',
  },
};

export default CartPage;
